import { useContext } from 'react'

import DataProcessOptionsContext from 'contexts/DataProcessOptionsContext'

const useDataProcessOptions = () => {
  const context = useContext(DataProcessOptionsContext)

  if (context === undefined) {
    throw new Error(
      'useDataProcessOptions must be used within a DataProcessOptionsContext.Provider',
    )
  }

  return {
    data: context.data,
    dataProcesses: context.dataProcesses,
    dataProcessTemplate: context.dataProcessTemplate,
    isLoading: context.isLoading,
    loadData: context.loadData,
    reload: context.reload,
    setDataProcesses: context.setDataProcesses,
    setReload: context.setReload,
    setSourceOptions: context.setSourceOptions,
    sourceOptions: context.sourceOptions,
  }
}

export default useDataProcessOptions
